export default __webpack_public_path__ + "psn-feedback-web.c9b50981cfee252319bfe4abcab8440e.css";